import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import NylAlert from '../../common/components/NylAlert';

const bodyTextClassname = "nyl-alert__body__text";
const strongTextClassname = `${bodyTextClassname}--strong`
const anchorClassname = `${bodyTextClassname}--anchor`;

const NewUserAlertDescription = withRouter(({ location: { search } }) => (
  <p className={classNames(bodyTextClassname, 'text-center', 'mb-0')}>
    <a href={`/register${search}`} className={anchorClassname}>
      <strong className={strongTextClassname}>
        Create an account
      </strong>
    </a> today and discover the possibilities!
  </p>
));

const NewUserAlert = () => {
  return (
    <NylAlert
      title="New to the App?"
      titleHeadingLevel={2}
      body={<NewUserAlertDescription />}
    />
  );
};

export default NewUserAlert;
